import React from "react";
import { useHistory } from "react-router-dom";
import FollowUserListView from "presentational/portfolio/followUserList/FollowUserListView";
import CommonModalView from "presentational/common/modals/CommonModalView";
import TXT from "presentational/common/multinational/TXT";
import { getDeviceType } from "lib/deviceInfo";
import config from "lib/fr-config";
import { getEssentialUrl } from "lib/urlQueryParser";
import PropTypes from "prop-types";

const MAX_FOLLOW_USER_COUNT = config.followUser.MAX_COUNT;

const desktopCss = config.css.desktop;
const mobileCss = config.css.mobile;

const cssXL = {
  content: {
    paddingLeft: desktopCss.sidePadding,
    paddingRight: desktopCss.sidePadding
  },
  paper: {
    maxWidth: 400,
    width: "50%",
    minWidth: 300
  }
};
const cssXS = {
  content: {
    paddingLeft: mobileCss.sidePadding,
    paddingRight: mobileCss.sidePadding
  },
  paper: {
    maxWidth: 400,
    width: "50%",
    minWidth: 300
  }
};

FollowListModal.propTypes = {
  open: PropTypes.bool.isRequired,
  modalType: PropTypes.oneOf(["following", "follower"]),
  userList: PropTypes.array.isRequired,
  followingNum: PropTypes.number.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isEnd: PropTypes.bool.isRequired,
  onRequestBtnClick: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
};

function FollowListModal(props) {
  const {
    open,
    modalType,
    userList,
    followingNum,
    isLoading,
    isEnd,
    onRequestBtnClick,
    onClose
  } = props;

  const history = useHistory();

  const deviceType = getDeviceType();
  const css = deviceType === "mobile" ? cssXS : cssXL;

  const getPercentOfFollowUser = () => {
    if (followingNum > MAX_FOLLOW_USER_COUNT) return "100%";

    const pcntNum = Math.floor((followingNum * 100) / MAX_FOLLOW_USER_COUNT);

    if (pcntNum >= 80) return `${pcntNum}%`;
    else return " ";
  };

  const handleUserUnitClick = ({ name }) => {
    onClose();
    history.push(getEssentialUrl({ type: "portfolio" })(name));
  };

  return (
    <div>
      <CommonModalView
        open={open}
        onClose={onClose}
        paperStyle={css.paper}
        titleText={
          modalType === "following" ? (
            <TXT
              name="titleModal_followingList"
              input={{ percent: getPercentOfFollowUser() }}
            />
          ) : modalType === "follower" ? (
            <TXT name="titleModal_followerList" />
          ) : (
            ""
          )
        }
        contentComponent={
          <FollowUserListView
            list={userList}
            isLoading={isLoading}
            isEnd={isEnd}
            onRequestBtnClick={onRequestBtnClick}
            onClick={handleUserUnitClick}
          />
        }
        firstButtonText={<TXT name="btnModal_close" />}
        firstButtonFunc={onClose}
      />
    </div>
  );
}

export default FollowListModal;
